import { withConfiguration } from "./config";

const b64DecodeUnicode = str => {
  return decodeURIComponent(
    Array.prototype.map
      .call(atob(str), c => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );
};
const getPayload = token => {
  const splittoken = token !== undefined ? token.split(".") : undefined;
  try {
    return splittoken !== undefined && splittoken.length === 2
      ? JSON.parse(b64DecodeUnicode(splittoken[1]))
      : undefined;
  } catch (err) {
    return undefined;
  }
};

const getQueryStringValue = key => {
  return decodeURIComponent(
    window.location.search.replace(
      new RegExp(
        "^(?:.*[&\\?]" +
          encodeURIComponent(key).replace(/[.+*]/g, "\\$&") +
          "(?:\\=([^&]*))?)?.*$",
        "i"
      ),
      "$1"
    )
  );
};

const AUTH_STORAGE = "auth";
const TOKEN_STORAGE = "token";
const MERCHANT_STORAGE = "merchant";

const getToken = () => getQueryStringValue("token");

export const authentication = () => {
  const token = getToken();

  const merchant = {
    code: getQueryStringValue("merchant"),
    kind: getQueryStringValue("kind"),
    name: getQueryStringValue("name"),
    resort: getQueryStringValue("resort")
  };

  if (token.length === 0 || merchant.code.length === 0) {
    return undefined;
  }
  const auth = getPayload(token);

  sessionStorage[AUTH_STORAGE] = JSON.stringify(auth);
  sessionStorage[TOKEN_STORAGE] = token;
  sessionStorage[MERCHANT_STORAGE] = JSON.stringify(merchant);

  return auth;
};

export const authenticated = () => {
  const authStr = sessionStorage[AUTH_STORAGE];
  if (authStr !== undefined) {
    const auth = JSON.parse(sessionStorage[AUTH_STORAGE]);
    auth.currentMerchant = JSON.parse(sessionStorage[MERCHANT_STORAGE]);
    return auth;
  }
};

export const getSlugs = async () => {
  const currentMerchant = JSON.parse(sessionStorage[MERCHANT_STORAGE]);
  if (
    currentMerchant !== undefined &&
    currentMerchant.resortslug === undefined
  ) {
    const resortResp = currentMerchant.resort
      ? await fetch(
          `${withConfiguration(config => config.msem.api)}/api/slug-by-resort/${
            currentMerchant.resort
          }`
        )
      : undefined;
    const resortslug = await resortResp.text();

    const merchantResp = currentMerchant.code
      ? await fetch(
          `${withConfiguration(config => config.server)}api/informations/slug/${
            currentMerchant.code
          }`
        )
      : undefined;
    const merchantslug = await merchantResp.text();

    sessionStorage[MERCHANT_STORAGE] = JSON.stringify({
      ...currentMerchant,
      resortslug,
      merchantslug
    });
    return {
      resortslug,
      merchantslug
    };
  }
};

export const token = () => {
  return sessionStorage[TOKEN_STORAGE];
};



// WEBPACK FOOTER //
// ./src/services/auth.js